var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-w-arrow text-15 md-text-17 font-unica leading-none flex items-center pt-12 px-15 pb-10 border hover-text-app-text hover-border-blue trans-fast"},[_c('arrow-down-right',{staticClass:"mr-8",staticStyle:{"width":"1.7rem","transform":"translateY(-.1rem)"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }